module.exports = __webpack_public_path__ + "img/hr-stone-path-transitions.c106063a.png";